
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { Email } from './../model/messaging.model';

@Injectable()
export class MessagingService {
    @LocalStorage() url: Url;

    public headers = new Headers({ 'Content-Type': 'application/json' });
    

    constructor(public http:HttpClient) { 
    }
    

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }

    sendPush(data: any): Observable<any> { 
        return this.http.post<any>(this.url.rest + '/tms/sendPush', data, this.httpOptions)
                .pipe(
                    retry(1),
                    catchError(this.handleError)     
                )
    }

    sendSMS(data: any): Observable<any> { 
        return this.http.post<any>(this.url.rest + '/tms/sendSMS', data, this.httpOptions)
                .pipe(
                    retry(1),
                    catchError(this.handleError)     
                )
    }

    sendEmail(data: Email): Observable<Email> { 
        return this.http.post<Email>(this.url.rest + '/tms/sendEmail', data, this.httpOptions)
                .pipe(
                    retry(1),
                    catchError(this.handleError)     
                )
    }
       
   // Error handling
   handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
    } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
}

} 